import { UserType } from 'utils/constants';
import ISorensonUser from 'utils/interfaces/sorenson-user.interface';
import { removePhoneFormat } from 'utils/services/format-phone-number';
import { getPasscodeFromURL } from '.';

const getRequestBody = (
  link: string,
  sorensonUser: ISorensonUser,
  ip: string,
  zoomUserId: string,
  token: string,
  location?: string,
  phone?: string,
  language?: string,
  billingName?: string,
  billingId?: string
) => {
  const commonBody = {
    endpointProductName: "Sorenson for Zoom",
    endpointProductVersion: process.env.REACT_APP_PRODUCT_VERSION,
    zoomURL: link,
    passcode: getPasscodeFromURL(link),
    zoomUserId,
  };
  const vriBody = {
    email: sorensonUser.email,
    location: location !== 'None' ? location : '',
    billingName: billingName || '',
    billingId: billingId || '',
    token: token || '',
    displayName: sorensonUser.name,
  };
  const vrsBody = {
    deafPhone: sorensonUser.phoneNumber?.toString(),
    hearingPhone: phone ? removePhoneFormat(phone) : '',
    publicIP: ip,
    interpreterLanguage: language,
    displayName: 'Unknown caller', // relay will replace with a look up using deafPhone
  };
  const userTypeBody =
    sorensonUser.userType === UserType.VRI ? { ...vriBody } : { ...vrsBody };

  return { ...commonBody, ...userTypeBody };
};

export default getRequestBody;
